export default {
	CONFIG: 'config',
	CONFIGURATOR_OUTPUT_TYPE: 'configuratorOutputType',
	CONFIGURATOR_TYPE: 'configuratorType',
};
